import React from "react";
import { Spinner } from "components/common";
import connect from "stores/connect";
import { EventDefinitionsActions, EventDefinitionsStore } from "stores/event-definitions/EventDefinitionsStore";
import CorrelationForm from "./CorrelationForm";
import EventsLicenseStatus from "./EventsLicenseStatus";
import { EventsLicenseStore, EventsLicenseActions } from "./EventsLicenseStore";
class CorrelationFormContainer extends React.Component {
  componentDidMount() {
    EventDefinitionsActions.listAll();
    EventsLicenseActions.getLicenseStatus();
  }
  render() {
    const { eventDefinitions, eventsLicenseStatus, ...otherProps } = this.props;
    const isLoading = !eventDefinitions.all || eventsLicenseStatus.loading;
    if (isLoading) {
      return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Event Definitions..." });
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EventsLicenseStatus, { licenseStatus: eventsLicenseStatus }), /* @__PURE__ */ React.createElement(CorrelationForm, { ...otherProps, eventDefinitions: eventDefinitions.all }));
  }
}
CorrelationFormContainer.defaultProps = {
  eventDefinitions: void 0
};
export default connect(CorrelationFormContainer, {
  eventDefinitions: EventDefinitionsStore,
  eventsLicenseStatus: EventsLicenseStore
});
